const colors = {
  black: "#1C1C1C",
  tealGreen: "#00897B",
  lightGray: "#F7F7F7",
  darkGray: "#8E8B8B",
};
export default colors;
